export const opacitySteps = [20, 16, 12, 8, 4];
export const getHexWithOpacity = (hex, itemIndex) => {
  const percent = opacitySteps[itemIndex] || 4;
  hex = hex.replace(/^#/, '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const alpha = Math.round((percent / 100) * 255)
    .toString(16)
    .padStart(2, '0');

  return `#${hex}${alpha}`;
};
